<template>
  <div class="navigation">

    <div class="navigation__line">
      <router-link
        to="/mobile"
        class="navigation__link navigation__link_back">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 123.5 102.7" v-bind:class="'navigation__icon navigation__icon_back'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M47.6 98.1c2.9 2.9 7.7 2.9 10.6 0 2.9-2.9 2.9-7.7 0-10.6L29.4 58.7h83.5c4.1 0 7.5-3.4 7.5-7.5s-3.4-7.5-7.5-7.5H29.4l28.8-28.8c2.9-2.9 2.9-7.7 0-10.6C56.7 2.8 54.8 2 52.9 2s-3.8.7-5.3 2.2L6 45.8c-1.4 1.4-2.2 3.3-2.2 5.3S4.6 55 6 56.4l41.6 41.7z"/></svg>
          <span class="navigation__text">Наши форматы</span>
      </router-link>
    </div>

    <div
      class="navigation__line"
      :class="{
        'navigation__line_active': doc_id == 'requirements',
        'navigation__line_opened': is_requirements_menu_opened
      }">
      <span class="navigation__icon-wrap" @click="toggleSubMenu('requirements')">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" v-bind:svg-inline="''" v-bind:class="'navigation__icon navigation__icon_open'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M0 6a.5.5 0 01.853-.354l8.646 8.646 8.646-8.646a.5.5 0 01.707.707l-9 9a.5.5 0 01-.707 0l-9-9a.498.498 0 01-.146-.354z"/></svg>
      </span>
      <router-link
        @click.native="toggleMainMenu"
        :to="{
          name: 'Requirements',
          params: {id: 'mobile_native_unit'}
        }"
        class="navigation__link"
        :class="{'navigation__link_active': doc_id == 'requirements'}">
          <span class="navigation__text">Технические требования форматов</span>
      </router-link>
      <div v-bar v-if="doc_id == 'requirements'" class="navigation__requirements">
        <div class="requirements-menu">
          <router-link
            @click.native="toggleMainMenu"
            class="requirements-menu__item"
            :class="{'requirements-menu__item_hide': item.hidden}"
            v-for="(item, index) in requirements_menu_data"
            :key="index"
            :to="{
              name: 'Requirements',
              params: {id: item.url_id}
            }"
            >
              <div
                class="requirements-menu__name"
                :class="{'requirements-menu__name_active': req_id == item.url_id}"
              >
                {{ item.name }}
              </div>
          </router-link>
        </div>
      </div>
    </div>

    <div class="navigation__line">
      <router-link
        v-if="!is_mobile_device"
        @click.native="toggleMainMenu"
        :to="{
          name: 'Documentation',
          params: {doc_id: 'validator'}
        }"
        class="navigation__link navigation__link_validator">
          <span class="navigation__text">Баннерный валидатор</span>
      </router-link>
    </div>

    <div class="navigation__line">
      <router-link
        @click.native="toggleMainMenu"
        :to="{
          name: 'Documentation',
          params: {doc_id: 'vast_vpaid_validator'}
        }"
        class="navigation__link navigation__link_validator">
          <span class="navigation__text">VAST/VPAID валидатор</span>
      </router-link>
    </div>

    <div
      class="navigation__line"
      :class="{
        'navigation__line_active': doc_id == 'instructions',
        'navigation__line_opened': is_instructions_menu_opened
      }">
      <span class="navigation__icon-wrap" @click="toggleSubMenu('instructions')">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" v-bind:svg-inline="''" v-bind:class="'navigation__icon navigation__icon_open'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M0 6a.5.5 0 01.853-.354l8.646 8.646 8.646-8.646a.5.5 0 01.707.707l-9 9a.5.5 0 01-.707 0l-9-9a.498.498 0 01-.146-.354z"/></svg>
      </span>
      <router-link
        @click.native="toggleMainMenu"
        :to="{
          name: 'Documentation',
          params: {doc_id: 'instructions'}
        }"
        class="navigation__link">
          <span class="navigation__text">Интеграция кода на сайт</span>
      </router-link>
      <div v-bar v-if="doc_id == 'instructions'" class="navigation__embed-instructions">
        <div class="instructions-menu">
          <div class="instructions-menu__wrap">
            <div
              v-for="(topic, index) in instructions_menu_data"
              :key="index"
              class="drop-menu"
              :class="{'drop-menu_opened': topic.opened}"
            >
              <div class="drop-menu__title">
                <span class="drop-menu__icon" @click="topic.opened = !topic.opened">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" v-bind:class="'icon icon_black icon_no-hover'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M0 6a.5.5 0 01.853-.354l8.646 8.646 8.646-8.646a.5.5 0 01.707.707l-9 9a.5.5 0 01-.707 0l-9-9a.498.498 0 01-.146-.354z"/></svg>
                </span>
                <a
                  class="drop-menu__name"
                  :href="topic.id"
                  @click="toggleMainMenu"
                >{{ topic.title }}</a>
              </div>
              <ul class="drop-menu__list" v-if="topic.nested.length > 0">
                <li
                  class="drop-menu__item"
                  v-for="(nestedTopic, index) in topic.nested"
                  :key="index">
                  <div
                    v-if="nestedTopic.nested.length > 0"
                    class="drop-menu"
                    :class="{'drop-menu_opened-nested': nestedTopic.opened}"
                  >
                    <div class="drop-menu__title">
                      <span class="drop-menu__icon-nested" @click="nestedTopic.opened = !nestedTopic.opened">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" v-bind:class="'icon icon_black icon_no-hover'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M0 6a.5.5 0 01.853-.354l8.646 8.646 8.646-8.646a.5.5 0 01.707.707l-9 9a.5.5 0 01-.707 0l-9-9a.498.498 0 01-.146-.354z"/></svg>
                      </span>
                      <a
                        class="drop-menu__name"
                        :href="nestedTopic.id"
                        @click="toggleMainMenu">
                        {{ nestedTopic.title }}
                      </a>
                    </div>
                    <ul class="drop-menu__list-nested">
                      <li
                        class="drop-menu__item"
                        v-for="(deepNestedTopic, index) in nestedTopic.nested"
                        :key="index"
                      >
                        <a
                          class="drop-menu__link"
                          :href="deepNestedTopic.id"
                          @click="toggleMainMenu">
                          {{ deepNestedTopic.title }}
                        </a>
                      </li>
                    </ul>
                  </div>
                  <a
                    v-else class="drop-menu__link"
                    :href="nestedTopic.id"
                    @click="toggleMainMenu">
                    {{ nestedTopic.title }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import MENU_DATA from '@/constants.js';
import Vuebar from 'vuebar';
import Vue from 'vue';
import { isMobile } from 'mobile-device-detect';

Vue.use(Vuebar);

export default {
  name: 'documentationMenu',
  props: {
    doc_id: {
      type: String,
    },
    req_id: {
      type: String,
    },
    is_menu_opened: {
      type: Boolean,
    },
  },
  model: {
    event: 'change',
    prop: 'is_menu_opened',
  },
  data() {
    return {
      is_instructions_menu_opened: false,
      is_requirements_menu_opened: false,
      is_mobile_device: isMobile,
      requirements_menu_data: MENU_DATA.REQUIREMENTS,
      instructions_menu_data: MENU_DATA.INSTRUCTIONS,
    };
  },
  methods: {
    toggleMainMenu() {
      this.$emit('change', !this.is_menu_opened);
    },
    toggleSubMenu(name) {
      this[`is_${name}_menu_opened`] = !this[`is_${name}_menu_opened`];
    },
  },
  mounted() {
    if (this.doc_id === 'requirements') {
      this.is_requirements_menu_opened = true;
    }
    if (this.doc_id === 'instructions') {
      this.is_instructions_menu_opened = true;
    }
  },
};
</script>

<style scoped lang='stylus'>
@import '../../styles/main.styl'

.navigation
  width 100%
  height 100%
  text-align center
  display flex
  flex-direction column
  &__line
    position relative
    &_active
      min-height auto
    &^[1]_opened
      max-height calc(100% - 165px)
      height auto
      // min-height 400px
      // +max-h-650()
      //   max-height calc(100% - 110px)
      //   min-height calc(100% - 110px)
  &__link
    width 100%
    display block
    margin-bottom 4px
    padding 12px 12px 12px 32px
    text-align left
    text-decoration none
    border-radius 8px
    box-sizing border-box
    -webkit-tap-highlight-color transparent
    overflow hidden
    font-size 0
    line-height 0
    color black
    &:hover
      background-color #F5F7FA
    &.router-link-active,
    &_active
      background-color #FF5500
      color white
      &:hover
        background-color #FF5500
        color white
        cursor default
    &_back
      display flex
      align-items center
      color #ff5502
      padding 12px
    &_validator
      padding 12px
  &__icon-wrap
    position absolute
    left 12px
    top 17px
    z-index 2
    pointer-events none
    ^[0]__line_active &
      pointer-events all
  &__icon
    display inline-block
    vertical-align middle
    margin-right 5px
    outline none
    border 0
    cursor pointer
    &_open
      width 13px
      height 10px
      fill $black
      transform rotate(-90deg)
      ^[0]__line_active &
        fill $white
      ^[0]__line_opened &
        transform rotate(0deg)
    &_back
      width 12px
      height 10px
      fill #ff5502
  &__text
    display inline-block
    vertical-align middle
    font-size 14px
    line-height 20px
    font-family 'Roboto', sans-serif
    font-weight 500
  &__requirements,
  &__embed-instructions
    height calc(100% - 50px)
    display none
    ^[0]__line_opened &
      display block

.instructions-menu
  flex-shrink 0
  font-family 'Roboto', Avenir, Helvetica, Arial, sans-serif
  padding 5px 10px
  fontSize(14, 20)

.requirements-menu
  &__item
    display flex
    align-items center
    justify-content space-between
    font-family 'Roboto', Avenir, Helvetica, Arial, sans-serif
    padding 4px 10px 4px 22px
    text-decoration none
    &_hide
      display none
  &__link-icon
    width 20px
    height 20px
    flex-shrink 0
    fill #cccccc
  &__name
    fontSize(14,23)
    color $black
    cursor pointer
    &:hover
      opacity 0.6
    &_active
      font-weight bold
      &:hover
        opacity 1
        cursor default

.drop-menu
  width 100%
  text-align left
  &__title
    position relative
    display flex
    align-items center
    padding 4px 10px 4px 0px
    box-sizing border-box
    cursor pointer
    ^[0]_active &
      background $smoke
      border-left 2px solid $lightYellow
  &__name
    display inline-block
    fontSize(14,23)
    color $black
    // font-weight bold
    text-decoration none
    &:hover
      opacity 0.6
  &__icon
    flex-shrink 0
    width 9px
    height 10px
    padding 10px
    transform rotate(-90deg)
    ^[0]_opened-nested &
    ^[0]_opened &
      transform rotate(0deg)
  &__icon-nested
    width 9px
    height 10px
    padding 10px
    transform rotate(-90deg)
    ^[0]_opened-nested &
      transform rotate(0deg)
  &__list
    display none
    padding 0px 0 5px 15px
    list-style none
    margin 0
    ^[0]_opened &
      display block
  &__list-nested
    display none
    padding 0px 0 5px 15px
    list-style none
    margin 0
    ^[0]_opened-nested &
      display block
  &__link
    display block
    fontSize(13,17)
    cursor pointer
    text-decoration none
    color $black
    &:hover
      opacity 0.6
  &__item
    padding 5px
    &_active
      background $smoke
      border-left 2px solid $lightYellow

</style>
